import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import DeviceRowCategory from "./DeviceRowCategory";
import GroupSubscriptionControls from "./GroupSubscriptionControls";

export default function DeviceGroup({
  group,
  category,
  collapsedGroups,
  toggleGroupCollapse,
  filter,
  calculateBounds,
  setMapCenter,
  setMapZoom,
  setCalcZoom,
  selectedDevices,
  toggleDevice,
  handleSave,
  saveSuccess,
  auth,
  setLoginPopupOpen,
  triggerLoginOpen,
  showSettingsState,
  ...props
}) {
  const groupKey = `${category}-${group.id}`;
  const isCollapsed = collapsedGroups[groupKey] ?? true;

  // Filter devices based on search filter
  const filteredDevices = group.devices.filter((device) => {
    return true
    if (!filter) return true;
    return device.alias.toLowerCase().includes(filter.toLowerCase());
  });

  // Count active/alerting vs idle devices for this group
  const alertingCount = group.devices.reduce(
    (acc, device) => acc + (device?.status >= 1 ? 1 : 0),
    0
  );

  const handleGroupToggle = () => {
    toggleGroupCollapse(groupKey);

    // If expanding, zoom to show all devices (both single and multi-device groups)
    if (
      isCollapsed &&
      calculateBounds &&
      setMapCenter &&
      setMapZoom &&
      setCalcZoom
    ) {
      const bounds = calculateBounds(group.devices);
      if (bounds) {
        setMapCenter(bounds.center);
        setMapZoom(bounds.zoom);
        setCalcZoom(bounds.zoom);
      }
    }
  };

  return (
    <div style={{ marginLeft: 20, marginTop: 10 }}>
      {/* Group Header */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 12px",
          backgroundColor: "#2a4a6b",
          borderRadius: 5,
          marginBottom: 5,
          cursor: "pointer",
        }}
        onClick={handleGroupToggle}
      >
        {alertingCount > 0 && (
          <div style={{
            marginRight: 10,
            backgroundColor: "#ffcc00", // Yellow background for warning
            color: "black",
            width: "25px",
            height: "25px",
            borderRadius: "25px",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
            border: "2px solid white",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}>!</div>
        )}
        {/* Left side - Group info */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
          }}
        >
          <div style={{ color: "white", fontWeight: "bold", fontSize: 18 }}>
            {group.name}
          </div>
          <div style={{ fontSize: 14, color: "#ccc" }}>
            {group.devices.length} device{group.devices.length !== 1 ? "s" : ""}
            {alertingCount > 0 && (
              <span style={{ color: "#ff6b6b", marginLeft: 10 }}>
                {alertingCount}{" "}
                {category === "Road Closures" ? "closed" : "alerting"}
              </span>
            )}
          </div>
        </div>

        {/* Right side - Collapse/expand toggle */}
        <div style={{ color: "white" }}>
          {isCollapsed ? (
            <FaChevronDown size={16} />
          ) : (
            <FaChevronUp size={16} />
          )}
        </div>
      </div>

      {/* Group Content */}
      {!isCollapsed && (
        <>
          {/* Subscription Controls - ALWAYS show when group is expanded */}
          <GroupSubscriptionControls
            group={group}
            selectedDevices={selectedDevices}
            toggleDevice={toggleDevice}
            handleSave={handleSave}
            saveSuccess={saveSuccess}
            auth={auth}
            setLoginPopupOpen={setLoginPopupOpen}
            triggerLoginOpen={triggerLoginOpen}
          />

          {/* Group Devices */}
          <div
            style={{
              marginLeft: 15,
              borderLeft: "2px solid #436c9a",
              paddingLeft: 10,
            }}
          >
            {filteredDevices.length === 0 && filter ? (
              <div style={{ color: "#ccc", fontStyle: "italic", padding: 10 }}>
                No devices match "{filter}"
              </div>
            ) : (
              filteredDevices.sort((a, b) => {
                const isAAlerting = a.status >= 1;
                const isBAlerting = b.status >= 1;
                if (isAAlerting && !isBAlerting) return -1; // a is alerting, b is not
                if (!isAAlerting && isBAlerting) return 1; // b is alerting, a is not
                // If both are alerting or both are idle, sort by alias
                return a.alias.toLowerCase().localeCompare(b.alias.toLowerCase());
              }).map((device) => (
                <DeviceRowCategory
                  key={`${device.id}-${device.node_id}`}
                  device={device}
                  filter={filter}
                  setMapCenter={setMapCenter}
                  setMapZoom={setMapZoom}
                  setCalcZoom={setCalcZoom}
                  {...props}
                />
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}
